var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIconHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_000000ff",
    "data-name": "#000000ff",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.257,
    height: 14.761,
    viewBox: "0 0 20.257 14.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15774",
    "data-name": "Path 15774",
    d: "M16.585,64.213a.647.647,0,0,1,.649-.147.614.614,0,0,1,.414.7.887.887,0,0,1-.329.471q-6.8,6.63-13.6,13.261a.788.788,0,0,1-.481.289.618.618,0,0,1-.472-1.1q.854-.83,1.706-1.663a12.677,12.677,0,0,1-1.905-1.386A13.186,13.186,0,0,1,.14,71.814.882.882,0,0,1,0,71.476v-.14a1.021,1.021,0,0,1,.153-.345,12.829,12.829,0,0,1,1.652-2.084,12.5,12.5,0,0,1,3.361-2.484,11.027,11.027,0,0,1,9.376-.219l2.043-1.991M8.113,66.7a10.014,10.014,0,0,0-3.778,1.682,12.259,12.259,0,0,0-2.962,3.031,12.283,12.283,0,0,0,1.919,2.174A11.393,11.393,0,0,0,5.42,75.1c.526-.522,1.061-1.036,1.591-1.555A3.609,3.609,0,0,1,7.4,68.826a3.837,3.837,0,0,1,4.88-.417c.436-.416.865-.84,1.3-1.261a9.6,9.6,0,0,0-5.46-.449m.236,2.94a2.427,2.427,0,0,0-.768,1.54,2.383,2.383,0,0,0,.345,1.475c1.144-1.119,2.3-2.23,3.435-3.356a2.539,2.539,0,0,0-3.012.34Z",
    transform: "translate(0 -64.034)",
    fill: "#809fb8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15775",
    "data-name": "Path 15775",
    d: "M185.149,155.236c.313-.3.629-.6.945-.9a13.6,13.6,0,0,1,3.189,3.247,2,2,0,0,1,.317.576v.145a.829.829,0,0,1-.129.316,12.138,12.138,0,0,1-1.063,1.415,12.775,12.775,0,0,1-5.342,3.711,11.7,11.7,0,0,1-7.1.185l1.066-1.01a10.085,10.085,0,0,0,3.842.108,10.447,10.447,0,0,0,4.4-1.85,12.488,12.488,0,0,0,2.91-2.933A12.61,12.61,0,0,0,185.149,155.236Z",
    transform: "translate(-169.343 -150.868)",
    fill: "#809fb8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15776",
    "data-name": "Path 15776",
    d: "M234.841,232.37q.589-.561,1.181-1.12a3.494,3.494,0,0,1-.236,2.523,3.848,3.848,0,0,1-2.185,1.894,4.074,4.074,0,0,1-2.341.1q.588-.561,1.18-1.119a2.645,2.645,0,0,0,1.785-.851A2.4,2.4,0,0,0,234.841,232.37Z",
    transform: "translate(-222.181 -224.822)",
    fill: "#809fb8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconHide);
export default __webpack_public_path__ + "static/media/eye-icon-hide.609ed074dc3f7b30bf4776b51a613076.svg";
export { ForwardRef as ReactComponent };